import { INVOICES_CRUD_ACTION_CREATORS } from '../actions/invoices_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess, softError } from '../actions/session_actions';
import { message } from 'antd';
import { retrieveCachedUserDetails } from './session_thunks';
import { QUOTES_CRUD_ACTION_CREATORS } from '../actions/quotes_actions';
import { getInvoiceSubAPIURL } from '../components/invoice_utilities/InvoiceUtilities';

export const invoicesRestCrudThunksForBuyer = new RestCrudThunks(
	'invoices',
	'invoice',
	'invoice',
	'invoices',
	INVOICES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'invoice/'
);

export const invoicesRestCrudThunksForSupplier = new RestCrudThunks(
	'invoices',
	'invoice',
	'invoice',
	'invoices',
	INVOICES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'invoice/'
);

export const invoicesClientRestCrudThunks = new RestCrudThunks(
	'client_invoices',
	'client_invoice',
	'clientInvoice',
	'clientInvoices',
	INVOICES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'invoice/'
);

export const invoicesContractorRestCrudThunks = new RestCrudThunks(
	'contractor_invoices',
	'contractor_invoice',
	'contractorInvoice',
	'contractorInvoices',
	INVOICES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'invoice/'
);

export const invoicesSubcontractorRestCrudThunks = new RestCrudThunks(
	'subcontractor_invoices',
	'subcontractor_invoice',
	'subcontractorInvoice',
	'subcontractorInvoices',
	INVOICES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'invoice/'
);

const fetchUtils = new FetchUtils();
const BASE_URL = getBackendUri();

const getBuyerInvoiceStatusUrl = (status, eventId) =>
	`/api/v1/buyer/invoice/invoices/${status}/${eventId}`;

export const createInvoiceByInternalTech = (entity) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/invoice/invoices/by_internal_tech`;
	return (dispatch) => {
		dispatch(INVOICES_CRUD_ACTION_CREATORS.createStart(entity));
		return new Promise((resolve, reject) => {
			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.createError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.createSuccess(entity));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(INVOICES_CRUD_ACTION_CREATORS.createError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const invoiceStatusChangeForBuyer = (status, entity) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(INVOICES_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.patch(BASE_URL + getBuyerInvoiceStatusUrl(status, entity.id), {})
				.then((response) => response.json())
				.then((d) => {
					if (d.status === 'error') {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(INVOICES_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const fetchTaxLineItemsForBuyer = (id) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/buyer/invoice/tax_line_items/CAD`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};

export const fetchTaxLineItemsForSupplier = (id) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/invoice/tax_line_items/CAD`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};

export const downloadInvoicePDF = (id, userType, currentUser, record) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${getInvoiceSubAPIURL(userType, currentUser, record)}/${id}/generate_pdf`;
	return fetchUtils
		.fileRequest(baseUrl + apiUrl, {})
		.then((response) => {
			const dataType = response.type;
			const binaryData = [];
			binaryData.push(response);
			const downloadLink = document.createElement('a');
			downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
			downloadLink.setAttribute('download', `invoice-${id}`);
			document.body.appendChild(downloadLink);
			downloadLink.click();
			downloadLink.remove();
		})
		.catch((err) => console.log(err));
};
export const generateInvoicePDFForSupplier = (id, userType, currentUser, record) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${getInvoiceSubAPIURL(userType, currentUser, record)}/${id}/generate_pdf`;
	return {
		url: baseUrl + apiUrl,
		httpHeaders: { 'X-Auth-Token': retrieveCachedUserDetails(['token']).token },
	};
};

export const sendInvoiceByEmailForSupplier = (id, email, data) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/invoice/invoices/${id}/send_email/${email}`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};

export const getAllInvoiceDocumentsForSupplier = (id) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/invoice/invoices/${id}/all_documents`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};

export const getInvoiceCheckInImagesForSupplier = (id) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/invoice/invoices/${id}/checkin_images`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};

export const getInvoiceCheckOutImagesForSupplier = (id) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/invoice/invoices/${id}/checkout_images`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};

export const getInvoiceNumber = (id, supplierFacilityId) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/invoice/invoices?invoiceNumber=${id}&supplierFacilityId=${supplierFacilityId}`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};
export const getInvoiceNumberBuyer = (id, supplierFacilityId) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/buyer/invoice/invoices?invoiceNumber=${id}&supplierFacilityId=${supplierFacilityId}`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};

export const updateInvoiceStatusBulk =
	(roleType) =>
	(ids, status, additionalParams = {}) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/invoice/status/action/bulk`;
		const entity = {
			ids: ids.map((id) => parseInt(id)),
			status: status,
			...additionalParams,
		};
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(INVOICES_CRUD_ACTION_CREATORS.updateStart(entity));
				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (d.status === 'error') {
							dispatch(INVOICES_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject('An error occurred in updating the selected invoices.' || d.message);
						} else {
							dispatch(INVOICES_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject('An error occurred in updating the selected invoices.' || d.message);
					});
			});
		};
	};

const updateInvoiceStatus =
	(invoiceStatus) =>
	(roleType) =>
	(entity, isClientView = false) => {
		const baseUrl = getBackendUri();

		let apiUrl = `/api/v1/${roleType}/invoice/status/${invoiceStatus}`;
		const { id, contractorWorkOrderId } = entity;
		if (id && contractorWorkOrderId) {
			if (isClientView) {
				apiUrl = `/api/v1/${roleType}/invoice/contractor_invoices/status/${invoiceStatus}`;
			} else {
				apiUrl = `/api/v1/${roleType}/invoice/subcontractor_invoices/status/${invoiceStatus}`;
			}
		}
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(INVOICES_CRUD_ACTION_CREATORS.updateStart(id));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(INVOICES_CRUD_ACTION_CREATORS.updateError(d.message, id));
							reject(d.message);
						} else {
							dispatch(INVOICES_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.updateError(d.message, id));
						reject(d.message);
					});
			});
		};
	};

const approveInvoice = updateInvoiceStatus('approved');
const disputeInvoice = updateInvoiceStatus('disputed');
const markInvoicePaid = updateInvoiceStatus('paid');
const markInvoiceProcessing = updateInvoiceStatus('processing');
const markInvoicePending = updateInvoiceStatus('pending');
const markInvoiceDraft = updateInvoiceStatus('draft');
const publishInvoice = updateInvoiceStatus('pending');
const voidInvoice = updateInvoiceStatus('void');
export const approveInvoiceForBuyer = approveInvoice(ROLE_TYPES.BUYER);
export const approveInvoiceForSupplier = approveInvoice(ROLE_TYPES.SUPPLIER);
export const disputeInvoiceForBuyer = disputeInvoice(ROLE_TYPES.BUYER);
export const disputeInvoiceForSupplier = disputeInvoice(ROLE_TYPES.SUPPLIER);
export const markInvoiceProcessingForBuyer = markInvoiceProcessing(ROLE_TYPES.BUYER);
export const markInvoiceProcessingForSupplier = markInvoiceProcessing(ROLE_TYPES.SUPPLIER);
export const markInvoicePendingForBuyer = markInvoicePending(ROLE_TYPES.BUYER);
export const markInvoicePendingForSupplier = markInvoicePending(ROLE_TYPES.SUPPLIER);
export const markInvoiceDraftForSupplier = markInvoiceDraft(ROLE_TYPES.SUPPLIER);
export const markInvoicePaidForBuyer = markInvoicePaid(ROLE_TYPES.BUYER);
export const publishInvoiceForSupplier = publishInvoice(ROLE_TYPES.SUPPLIER);
export const markInvoicePaidForSupplier = markInvoicePaid(ROLE_TYPES.SUPPLIER);
export const voidInvoiceForSupplier = voidInvoice(ROLE_TYPES.SUPPLIER);

const updateInvoiceField =
	(field) =>
	(roleType) =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/invoice/update_field/${field}`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(INVOICES_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(INVOICES_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(INVOICES_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

const updateInvoiceGLCode = updateInvoiceField('gl_code');
export const updateInvoiceGLCodeForBuyer = updateInvoiceGLCode(ROLE_TYPES.BUYER);
export const updateInvoiceGLCodeForSupplier = updateInvoiceGLCode(ROLE_TYPES.SUPPLIER);

const updateInvoicePONumber = updateInvoiceField('po_number');
export const updateInvoicePONumberForBuyer = updateInvoicePONumber(ROLE_TYPES.BUYER);
export const updateInvoicePONumberForSupplier = updateInvoicePONumber(ROLE_TYPES.SUPPLIER);

export const createInvoiceBasedOnWorkOrder =
	(workOrderId) =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/supplier/invoice/invoices/work_order/${workOrderId}`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(INVOICES_CRUD_ACTION_CREATORS.createStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(INVOICES_CRUD_ACTION_CREATORS.createError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(INVOICES_CRUD_ACTION_CREATORS.createSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.createError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

const createInvoiceForSupplierBasedOnWorkOrder = (userType) => (entity, workOrderId) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/invoice/invoices/work_order/${workOrderId}`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(INVOICES_CRUD_ACTION_CREATORS.createStart(entity));

			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.createError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.createSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(INVOICES_CRUD_ACTION_CREATORS.createError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const createInvoiceForSupplierBasedOnWorkOrderForBuyer =
	createInvoiceForSupplierBasedOnWorkOrder(ROLE_TYPES.BUYER);
export const createInvoiceForSupplierBasedOnWorkOrderForSupplier =
	createInvoiceForSupplierBasedOnWorkOrder(ROLE_TYPES.SUPPLIER);

export const downloadInvoiceCSV =
	(roleType, isSubcontractor) =>
	(params, filters = null) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/invoice/${
			roleType === ROLE_TYPES.SUPPLIER
				? isSubcontractor
					? 'subcontractor_invoices'
					: 'client_invoices'
				: 'invoices'
		}/csv_report_generator`;

		// if sorting present, fix order naming and add to query params

		if (filters) {
			params = {
				...params,
				...filters,
			};
		}

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.get(
						baseUrl + apiUrl,
						Object.assign(
							{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
							params
						)
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
							message.error(d.data);
						} else {
							resolve(d.data);
							const hide = message.loading(d.data, 0);
							setTimeout(hide, 7000);
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};

export const downloadInvoiceCSVForBuyer = downloadInvoiceCSV(ROLE_TYPES.BUYER);
export const downloadInvoiceCSVForSupplier = downloadInvoiceCSV(ROLE_TYPES.SUPPLIER);

const downloadInvoiceFormatCSV =
	(roleType) =>
	(formatName, params, filters = null) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/invoice/invoices/csv_report_generator/${formatName}`;

		// if sorting present, fix order naming and add to query params

		if (filters) {
			params = {
				...params,
				...filters,
			};
		}

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.get(
						baseUrl + apiUrl,
						Object.assign(
							{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
							params
						)
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
							message.error(d.data);
						} else {
							resolve(d.data);
							const hide = message.loading(d.data, 0);
							setTimeout(hide, 7000);
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};

export const downloadInvoiceFormatCSVForBuyer = downloadInvoiceFormatCSV(ROLE_TYPES.BUYER);
export const downloadInvoiceFormatCSVForSupplier = downloadInvoiceFormatCSV(ROLE_TYPES.SUPPLIER);

const invoiceDownloadFormat =
	(roleType) =>
	(params, filters = null) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/invoice/invoice_download_formats`;

		// if sorting present, fix order naming and add to query params

		if (filters) {
			params = {
				...params,
				...filters,
			};
		}

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.get(
						baseUrl + apiUrl,
						Object.assign(
							{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
							params
						)
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
							message.error(d.data);
						} else {
							resolve(d.data);
							const hide = message.loading(d.data, 0);
							setTimeout(hide, 7000);
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};

export const invoiceDownloadFormatForBuyer = invoiceDownloadFormat(ROLE_TYPES.BUYER);
export const invoiceDownloadFormatForSupplier = invoiceDownloadFormat(ROLE_TYPES.SUPPLIER);

const getCapExCategories =
	(roleType) =>
	(params = null, filters = null) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/categories/capex`;

		// if sorting present, fix order naming and add to query params

		if (filters) {
			params = {
				...params,
				...filters,
			};
		}

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.get(
						baseUrl + apiUrl,
						Object.assign(
							{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
							params
						)
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
						} else {
							resolve(d.data);
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};

export const fetchCapExCategoriesForBuyer = getCapExCategories(ROLE_TYPES.BUYER);
export const fetchCapExCategoriesForSupplier = getCapExCategories(ROLE_TYPES.SUPPLIER);

const getRMCategories =
	(roleType) =>
	(params = null, filters = null) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/categories/rm`;

		if (filters) {
			params = {
				...params,
				...filters,
			};
		}

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.get(baseUrl + apiUrl, Object.assign({}, params))
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
						} else {
							resolve(d.data);
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};

export const fetchRMCategoriesForBuyer = getRMCategories(ROLE_TYPES.BUYER);
export const fetchRMCategoriesForSupplier = getRMCategories(ROLE_TYPES.SUPPLIER);

export const syncInvoiceApprovalHierarchy = (userType) => (entity) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(INVOICES_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.patch(
					BASE_URL + `/api/v1/${userType}/invoice/invoices/approval_hierarchy_update/${entity.id}`,
					{}
				)
				.then((response: any) => response.json())
				.then((d) => {
					if (d.status === 'error') {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(INVOICES_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};
export const syncInvoiceApprovalHierarchyForBuyer = syncInvoiceApprovalHierarchy('buyer');
export const syncInvoiceApprovalHierarchyForSupplier = syncInvoiceApprovalHierarchy('supplier');

export const getContractorInvoices = (params, targetCollectionName) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/invoice/contractor_invoices`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(INVOICES_CRUD_ACTION_CREATORS.fetchStart(targetCollectionName));
			fetchUtils
				.get(
					baseUrl + apiUrl,
					Object.assign(
						{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
						params
					)
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.fetchError(d.message, targetCollectionName));
						reject(d.message);
					} else {
						dispatch(
							INVOICES_CRUD_ACTION_CREATORS.fetchSuccess(
								d.data,
								d.count,
								targetCollectionName,
								{
									...{},
									total: d.count,
								},
								{},
								{}
							)
						);
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(INVOICES_CRUD_ACTION_CREATORS.fetchError(d.message, targetCollectionName));
					reject(d.message);
				});
		});
	};
};

export const createInvoiceSubContractor = (entity) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(INVOICES_CRUD_ACTION_CREATORS.createStart(entity));

			fetchUtils
				.post(
					BASE_URL + '/api/v1/supplier/invoice/contractor_invoices',
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
				)
				.then((response: any) => response.json())
				.then((d) => {
					if (d.status === 'error') {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.createError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.createSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(INVOICES_CRUD_ACTION_CREATORS.createError(d.message, entity));
					reject(d.message);
				});
		});
	};
};
export const updateInvoiceSubContractor = (entity) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(INVOICES_CRUD_ACTION_CREATORS.createStart(entity));

			fetchUtils
				.put(
					BASE_URL + '/api/v1/supplier/invoice/contractor_invoices',
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
				)
				.then((response: any) => response.json())
				.then((d) => {
					if (d.status === 'error') {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.createError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.createSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(INVOICES_CRUD_ACTION_CREATORS.createError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const getOtherContractorInvoices = (params) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/invoice/contractor_invoices`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(
					baseUrl + apiUrl,
					Object.assign(
						{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
						params
					)
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};

export const getOtherInvoices = (params) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/invoice/invoices`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(
					baseUrl + apiUrl,
					Object.assign(
						{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
						params
					)
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};

export const bulkMarkInvoicesPaid = (roleType) => (data) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/invoice/status/paid/bulk`;

	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(INVOICES_CRUD_ACTION_CREATORS.updateStart({}));

			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data,
				})
				.then(parseJSON)
				.then(({ json, status }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.updateError(d.message, {}));
						// BE returns `error: [{invoiceId, workOrderId, errorMessage}, ...]` for
						// per-row failures. Forward that array so the caller can map each
						// entry back to its row; fall back to `message` for global errors.
						reject(d.error || d.message);
					} else {
						dispatch(INVOICES_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(INVOICES_CRUD_ACTION_CREATORS.updateError(d.message, {}));
					reject(d.message);
				});
		});
	};
};

export const getBulkMarkInvoicesPaidStatus = (roleType) => () => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/invoice/status/paid/bulk/status`;

	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				})
				.then(parseJSON)
				.then(({ json, status }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};
